/**
 * Logger Utility
 * 
 * Provides consistent logging functions for the application.
 */

// Log levels
const LOG_LEVELS = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEBUG: 'debug'
};

/**
 * Log information message
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const logInfo = (message, data) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c[INFO] ${message}`, 'color: #3182CE', data || '');
  }
};

/**
 * Log success message
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const logSuccess = (message, data) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c[SUCCESS] ${message}`, 'color: #38A169', data || '');
  }
};

/**
 * Log warning message
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const logWarning = (message, data) => {
  console.warn(`[WARNING] ${message}`, data || '');
};

/**
 * Log error message
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const logError = (message, data) => {
  console.error(`[ERROR] ${message}`, data || '');
};

/**
 * Log debug message (only in development)
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const logDebug = (message, data) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`%c[DEBUG] ${message}`, 'color: #805AD5', data || '');
  }
};

export default {
  logInfo,
  logSuccess,
  logWarning,
  logError,
  logDebug,
  LOG_LEVELS
};
